export const environment = {
  production: false,
  apiUrl: import.meta.env.VITE_API_URL,
  socketUrl: import.meta.env.VITE_SOCKET_URL,
  apiClient: import.meta.env.VITE_API_CLIENT,
  apiSecret: import.meta.env.VITE_API_SECRET,
  sentryDSN: import.meta.env.VITE_SENTRY_DSN,
  tinyMCEKey: import.meta.env.VITE_TINYMCE_KEY,
};
